export var card = 'bg-uiBg shadow-lg drop-shadow-lg rounded-15 text-black w-headercard';
export var imageWrapper = 'h-bannerimage w-full';
export var cardBanner = 'h-full w-full rounded-t-lg';
export var cardTitle = 'text-2xl font-bold text-left font-h1 text-primary ';
export var cardText = 'text-textLight text-left text-base leading-5';
export var statusChip = 'mt-4 mb-1.5';
export var cardInformation = 'px-4 pb-5 flex flex-col justify-space-between items-start h-36 overflow-hidden';
//# sourceMappingURL=header-card.styles.js.map